import { handleResponse } from "../helpers"
export const reverseGeocoding = async (lat, lon) => {
    const response = await fetch('https://nominatim.openstreetmap.org/reverse?format=json&lon=' + lon + '&lat=' + lat)
    return handleResponse(response)
}